exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports
exports.i(require("-!../../node_modules/css-loader/index.js??ref--6-oneOf-1-1!../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/postcss-loader/src/index.js??ref--6-oneOf-1-2!../../node_modules/postcss-loader/src/index.js??ref--6-oneOf-1-3!../assets/css/font-awesome.min.css"), "");

// module
exports.push([module.id, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"baseinfo.vue?vue&type=style&index=0&id=2f5547ca&scoped=true&lang=css&","sourceRoot":""}]);

// exports
